export const colors: { [key: string]: string } = {
  pending: "#FFD54F",
  approved: "#81C784",
  rejected: "#FFAB91",
  expired: "#9E9E9E",
};
